<div class="row" *ngIf="nonDeliverableItem.length === 0">
  <div class="col-md-8 col-sm-8"><span translate>T_BOM_ESTIMATED_DELIVERY_TIME</span> :</div>
  <div class="col-md-4 col-sm-4" >{{deliveryTime}} <span translate>T_BOM_DELIVERY_TIME_WEEKS</span></div>
</div>
<p *ngIf="nonDeliverableItem.length > 0"><label translate>T_BOM_UNKNOWN_DELIVERY_TIME</label>
  <span class="se-icons brand-warning"
     tooltip="{{'T_BOM_MORE_INFORMATION' | translate}}" placement="left">notification_critical_stroke</span>
</p>
